import type { ReactNode } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Breadcrumbs, BreadcrumbItem } from '@vnetwork/ui/layout';

/** A breadcrumb hop under the console base. Omit `slug` to mark the current page. */
export interface VodCrumb {
  label: ReactNode;
  /** Path segment under `/services/vod/:serviceId`; omit for the current (non-link) crumb. */
  slug?: string;
}

const ROOT_LABEL = 'Cloud Encoding';

/**
 * Consistent breadcrumb trail for every service-scoped Cloud Encoding page,
 * shown in the PageHeader's small text above the title. Always rooted at the
 * service dashboard ("Cloud Encoding"); pass the sub-page hops via `trail`. The
 * dashboard (console index) itself passes no trail (root renders as current).
 */
export function VodConsoleBreadcrumbs({ trail = [] }: { trail?: VodCrumb[] }) {
  const { serviceId } = useParams<{ serviceId: string }>();
  const base = `/services/vod/${serviceId}`;

  const items = [
    trail.length === 0 ? (
      <BreadcrumbItem key="root" current>{ROOT_LABEL}</BreadcrumbItem>
    ) : (
      <BreadcrumbItem key="root" asChild>
        <Link to={base}>{ROOT_LABEL}</Link>
      </BreadcrumbItem>
    ),
    ...trail.map((crumb, i) =>
      crumb.slug ? (
        <BreadcrumbItem key={i} asChild>
          <Link to={`${base}/${crumb.slug}`}>{crumb.label}</Link>
        </BreadcrumbItem>
      ) : (
        <BreadcrumbItem key={i} current>
          {crumb.label}
        </BreadcrumbItem>
      ),
    ),
  ];

  return <Breadcrumbs>{items}</Breadcrumbs>;
}
